export default __webpack_public_path__ + "static/media/tBTC-explorer-bg.5ac67338.svg";